import React from 'react';
import { connect } from 'react-redux';
import { MdClose } from 'react-icons/md';

import { closeAddedToCart } from '../../../../redux/modules/addedToCart';

import Link from '../../Link/Link';

import './AddedToCart.scss';
import { ImageDispatcher } from '../../ImageDispatcher/ImageDispatcher';

const AddedToCart = ({
  addedToCartOpen,
  productImage,
  closeAddedToCart,
  primaryColor,
  uiVariantButton,
}) => {
  const handleClickClose = event => {
    event.preventDefault();
    closeAddedToCart();
  };

  if (addedToCartOpen) {
    return (
      <div className="added-to-cart" style={{ backgroundColor: primaryColor }}>
        <div className="container">
          <div className="content">
            <div className="img-text">
              <ImageDispatcher
                src={productImage}
                style={{
                  borderRadius:
                    uiVariantButton === '1'
                      ? '12px'
                      : uiVariantButton === '3'
                      ? '6px'
                      : 0,
                }}
              />
              <div className="text">Prodotto aggiunto al carrello</div>
            </div>
            <div className="btn-close">
              <Link
                to="/carrello"
                className="btn btn-inverse go-to-cart"
                style={{ color: primaryColor }}
              >
                Vai al carrello
              </Link>
              <a className="btn close-cart" onClick={handleClickClose}>
                <MdClose />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

const mapStateToProps = state => ({
  addedToCartOpen: state.addedToCart.addedToCartOpen,
  productImage: state.addedToCart.productImage,
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantButton: state.store.data.uiVariants.buttons,
});

export default connect(mapStateToProps, { closeAddedToCart })(AddedToCart);
